import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import config from 'config';

import en from './resources/en/doctor_translations.json';
import de from './resources/de/doctor_translations.json';

const locale = localStorage.getItem('locale') || 'en';

const FOLDER_NAME = 'doctor_dashboard';
const FILE_NAME = 'doctor_translations';

const resources = {
  en: {
    translation: en
  },
  de: {
    translation: de
  }
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    resources,
    lng: locale,
    fallbackLng: locale,
    interpolation: {
      escapeValue: false
    },
    debug: false,
    backend: {
      loadPath: `${config.base_url}/aws-s3/get-data/${FOLDER_NAME}/{{lng}}/${FILE_NAME}`
    }
  });
